class PopupOptions {
  constructor() {
    this.trigger = document.querySelectorAll('[data-trigger="popupSingle"]');
    this.target = document.querySelector(".liste-produit");
    if (this.target) {
      this._init();
    }
  }

  _init() {
    document.addEventListener("DOMContentLoaded", event => {
      let o = "";
      this.trigger.forEach(item => {
        o += item.innerHTML;
      });

      this.target.innerHTML = o;
    });
  }
}

export const popupOptions = new PopupOptions();
